const menuItems = state => state.menu.menus
const authData = state => state.auth.authData
const user = state => state.user.user

export {
  menuItems,
  authData,
  user
}
